import { render, staticRenderFns } from "./AppPassword.vue?vue&type=template&id=f5cbc2a4&"
import script from "./AppPassword.vue?vue&type=script&lang=js&"
export * from "./AppPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports